import React, {useState} from 'react';
import {Grid, Card, CardActionArea, CardContent, CardMedia, Typography } from '@material-ui/core/';
import {useStyles} from './style';
import { functions } from 'constants/functions';

function DatosIdentidad(props) {
    const classes = useStyles();
    const datosDelCiudadano = [
        {title: "CUI del DPI ", value: props.datosDPI?.cui},
        {title: "Nombre ", value: ((props.datosDPI?.primer_nombre || '')+' '+(props.datosDPI?.segundo_nombre || '')+', '+
            (props.datosDPI?.primer_apellido ||'')+' '+(props.datosDPI?.segundo_apellido ||'')+', '+(props.datosDPI?.tercer_nombre||'')),},
        {title: "Fecha de Nacimiento ", value: functions.dateFormatGeneral(props.datosDPI?.fecha_nacimiento),},
        {title: "Género ", value: (props.datosDPI?.genero === "F" ? "Femenino" : "Masculino"),},
        {title: "Serie Del DPI ", value: props.datosDPI?.numero_serie,},
        {title: "Fecha de Emisión del DPI ", value: functions.dateFormatGeneral(props.datosDPI?.fecha_emision),},
        {title: 'País de Nacimiento ', value:(props.datosUbicacion?.paisNacimiento ||'')},
        {title: 'Lugar de Extensión ', value:(props.datosUbicacion?.deptoExtension || '')+' , '+(props.datosUbicacion?.municExtension ||'')},
        {title: 'Lugar de Vecindad ', value: (props.datosUbicacion?.deptoVecindad || '')+' , '+(props.datosUbicacion?.municVecindad ||'')},
        {title: 'Lugar de Nacimiento ', value:(props.datosUbicacion?.deptoNacimiento || '')+','+(props.datosUbicacion?.municNacimiento || '')},
        {title: "Nombre del Padre ", value: ((props.datosDPI?.primer_nombre_padre || '')+' '+(props.datosDPI?.segundo_nombre_padre || '')+', '+
            (props.datosDPI?.primer_apellido_padre ||'')+' '+(props.datosDPI?.segundo_apellido_padre ||'')),},
        {title: "Nombre de la Madre ", value: ((props.datosDPI?.primer_nombre_madre || '')+' '+(props.datosDPI?.segundo_nombre_madre || '')+', '+
            (props.datosDPI?.primer_apellido_mare ||'')+' '+(props.datosDPI?.segundo_apellido_madre ||'')),},
        
    ]
    return (
        <div>
            <Grid container className={classes.rootGrid} >
                <Grid className={classes.titleGrid} item xs={12} container direction="row" justify="center" alignItems="center">
                    <Typography className={classes.typographyTitle} variant="subtitle1" gutterBottom><strong>Datos del DPI</strong></Typography>                    
                </Grid >
                {datosDelCiudadano.map((value, index) => (
                    <Grid item xs={6} container direction="row" justifyContent="flex-start" alignItems="baseline">
                        <Typography className={classes.typography} variant="subtitle1"><strong>{value.title}</strong>: {value.value}</Typography>                    
                    </Grid >
                ))}
            </Grid>  
        </div>      
    );
}
export default DatosIdentidad;